import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../cache';
import { UserProfileSettingsService } from '../../system-services/UserProfileSettings/UserProfileSettings.service';

type MyBAStorage = {
    selfBASkipped: boolean;
    hasViewedProfileCover: boolean;
};

@Injectable({
    providedIn: 'root'
})
export class MyBaService {
    selfBAStorage: MyBAStorage = {
        selfBASkipped: false,
        hasViewedProfileCover: false
    };

    constructor(
        private localStorageService: LocalStorageService,
        private userProfile: UserProfileSettingsService
    ) {
        const localSelfBAStorage: MyBAStorage = this.getSelfBAFromStore();
        if (localSelfBAStorage) {
            this.selfBAStorage = localSelfBAStorage;
        }
    }

    isSelfBASkipped(): boolean {
        return this.selfBAStorage.selfBASkipped;
    }

    selfBAIsSkipped() {
        this.selfBAStorage.selfBASkipped = true;
        this.localStorageService.setItem(
            this.collectionName(),
            this.selfBAStorage
        );
    }

    hasViewedProfileCover() {
        return this.selfBAStorage.hasViewedProfileCover;
    }

    applyViewedProfileCover() {
        this.selfBAStorage.hasViewedProfileCover = true;
        this.localStorageService.setItem(
            this.collectionName(),
            this.selfBAStorage
        );
    }

    setViewedProfileCover(selfBAStorage: MyBAStorage) {
        this.selfBAStorage = selfBAStorage;
        this.localStorageService.setItem(this.collectionName(), selfBAStorage);
    }

    getSelfBAFromStore(): MyBAStorage {
        return this.localStorageService.getItem(this.collectionName());
    }

    private collectionName(): string {
        return `${this.userProfile.currentCompany}MyBA`;
    }
}
